export enum NavSectionsEnum {
  HOME = 'HOME',
  ABOUT = 'ABOUT',
  SKILLS = 'SKILLS',
  STUDIES = 'STUDIES',
  PORTFOLIO = 'PORTFOLIO',
  CONTACT = 'CONTACT',
}
